/* Prozone — ajout au panier sans quitter la page.

   Avant : le bouton « Ajouter au panier » de la fiche produit était un submit
   vers /cart/add, donc Shopify renvoyait sur /cart et coupait la navigation.
   Ici on poste en AJAX et on ouvre le mini-panier : le client reste où il est.

   Intégration avec pz-b2b.js : ce fichier n'expose aucune API publique (tout
   est enfermé dans une IIFE). Pour ouvrir le tiroir et le réhydrater, on
   déclenche donc un clic sur le bouton panier de l'en-tête, que pz-b2b.js
   écoute déjà — c'est indirect, mais ça réutilise son seul point d'entrée au
   lieu de dupliquer son rendu. */
(function () {
  'use strict';

  var CFG = window.pzB2B || {};
  var ROUTE = (CFG.routes && CFG.routes.cartAdd) || '/cart/add.js';

  function openDrawer() {
    var btn = document.querySelector('.pz-cart-btn');
    if (!btn) return false;
    btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, button: 0 }));
    return true;
  }

  function bumpBadge(count) {
    Array.prototype.forEach.call(document.querySelectorAll('.pz-cart-count'), function (el) {
      el.textContent = count;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pz-addbtn]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var form = btn.form || (btn.closest && btn.closest('form'));
    var idEl = form && form.querySelector('[name="id"]');
    var id = Number(btn.getAttribute('data-pz-addbtn') || (idEl && idEl.value) || 0);
    if (!id) return;

    var qtyEl = form && form.querySelector('[name="quantity"]');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

    var isIcon = btn.querySelector('svg') !== null && btn.textContent.trim() === '';
    var original = btn.innerHTML;

    btn.disabled = true;
    if (!isIcon) btn.textContent = 'Ajout en cours…';

    function restore() {
      btn.innerHTML = original;
      btn.disabled = false;
    }

    fetch(ROUTE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible.');
          return data;
        });
      })
      .then(function () {
        if (!isIcon) btn.textContent = 'Ajouté ✓';
        if (!openDrawer()) {
          /* Pas de mini-panier sur cette page : au moins tenir le compteur à jour. */
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) { bumpBadge(c.item_count); })
            .catch(function () {});
        }
        setTimeout(restore, 1400);
      })
      .catch(function (err) {
        restore();
        window.alert(err.message || 'Ajout impossible pour le moment.');
      });
  });
})();
